<template>
  <Row class="page3" style="padding-left: 4vw; padding-right: 4vw">
    <div
      style="width: 100%; height: 100%; display: flex; flex-direction: column"
    >
      <div style="height: 70%; background: rgba(87, 87, 87, 0.3)">
        <div class="nooverHeight" style="height: 100%">
          <div
            class="center-bottom"
            style="height: 100%; display: flex; align-items: center"
          >
            <div
              class="buPart four"
              style="width: 100%; display: flex; height: 100%"
            >
              <div
                style="width: 25%; cursor: pointer"
                @click="toEbitda(data5[0]['name'])"
              >
                <div class="changeRateTitle">
                  <span class="dot"></span>
                  <span class="word" style="font-size: 0.9vw; color: #bf9d63">{{
                    this.data5[0]["name"]
                  }}</span>
                </div>
                <div
                  v-if="!this.data5[0].isNoShow && showEbitda"
                  style="display: flex; align-items: center; margin-top: 2vw"
                >
                  <div
                    style="
                      font-size: 1vw;
                      opacity: 0.8;
                      margin-right: 1vw;
                      color: #96979a;
                    "
                  >
                    EBITDA
                  </div>
                  <div style="display: flex; align-items: center">
                    <span
                      style="font-size: 1.2vw; color: #fff; margin-right: 1vw"
                      >{{ this.data5[0]["value"] }}</span
                    ><span
                      style="opacity: 0.8; font-size: 0.8vw; color: #96979a"
                    >
                      <!-- （亿人民币） -->
                      ({{ data5[0]["unit"] }})
                    </span>
                  </div>
                </div>
                <div
                  style="
                    font-size: 1vw;
                    opacity: 0.8;
                    display: flex;
                    align-items: center;
                  "
                >
                  <div style="padding-right: 60px; color: #96979a">
                    {{ data5[0]["report"] }}
                  </div>
                  <div style="opacity: 1; color: #fff">
                    {{ data5[0]["date"] }}
                  </div>
                </div>
                <div style="width: 15vw; height: 15vw; margin-top: 2vw">
                  <ring
                    :data="data4"
                    v-if="data4 && data4[0] && data4[0].length > 0"
                  ></ring>
                </div>
              </div>
              <div
                style="
                  margin-top: 3vw;
                  height: 17vw;
                  background: #fff;
                  width: 1px;
                  opacity: 0.2;
                  margin-right: 2vw;
                "
              ></div>
              <div style="width: 100%; height: 100%" class="nooverHeight">
                <Row style="height: 100%">
                  <Col :span="24" class="yellowWrap">
                    <div v-if="roleName">
                      <div
                        style="
                          width: 100%;
                          border: solid 1px #bf9d63;
                          padding-left: 2vw;
                          padding-top: 2vw;
                          padding-bottom: 2vw;
                          margin-bottom: 15px;
                        "
                        v-for="(item1, index1) in groupData"
                      >
                        <div class="subWord">{{ index1 }}</div>
                        <div class="yellowList nooverHeight">
                          <div
                            v-for="item in item1"
                            @click="toIframe(item.company, item['风险名称'])"
                            style="width: 14vw; margin-right: 2vw"
                            class="yellowItem"
                          >
                            <div style="display: flex">
                              <div
                                :class="getDayDot(item)"
                                style="flex-shrink: 0; margin-top: 0.4vw"
                              ></div>
                              <div class="name">{{ item["风险名称"] }}</div>
                            </div>

                            <div
                              style="
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                color: #fff;
                                margin-top: 0.5vw;
                              "
                            >
                              <div>{{ item.key1 }}</div>
                              <div>{{ item.value1 }}</div>
                            </div>
                            <div
                              style="
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                color: #fff;
                                margin-top: 0.5vw;
                              "
                            >
                              <div>{{ item.key2 }}</div>
                              <div>{{ item.value2 }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="yellowList nooverHeight" v-else>
                      <div
                        v-for="item in data3"
                        @click="toIframe(item.company, item['风险名称'])"
                        class="yellowItem"
                      >
                        <div style="display: flex">
                          <div
                            :class="getDayDot(item)"
                            style="flex-shrink: 0; margin-top: 0.4vw"
                          ></div>
                          <div class="name">{{ item["风险名称"] }}</div>
                        </div>

                        <div
                          style="
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            color: #fff;
                            margin-top: 0.5vw;
                          "
                        >
                          <div>{{ item.key1 }}</div>
                          <div>{{ item.value1 }}</div>
                        </div>
                        <div
                          style="
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            color: #fff;
                            margin-top: 0.5vw;
                          "
                        >
                          <div>{{ item.key2 }}</div>
                          <div>{{ item.value2 }}</div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 2vw"></div>
      <div
        style="
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <div
          v-for="item in data2"
          class="changeRateWrap nooverHeight"
          style="height: 100%; width: 22%; flex: none; cursor: pointer"
        >
          <div
            class="changeRate"
            style="
              padding-top: 1.5vw;
              padding-bottom: 1.5vw;
              display: flex;
              flex-direction: column;
            "
          >
            <div
              class="buPart"
              style="
                display: flex;
                height: 100%;
                flex-direction: column;
                justify-content: space-between;
              "
            >
              <div
                class="buPartTitle"
                style="font-weight: 400; font-size: 1vw; color: #bf9d63"
              >
                {{ item.name }}
              </div>
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <div class="line">
                  <span
                    class="span1"
                    style="font-size: 1.8vw; font-weight: 700px; color: #fff"
                    >{{ item.value }}</span
                  >
                </div>
                <div class="line">
                  <span
                    v-if="Number(item.diff.replace('%', '')) > 0"
                    class="span1"
                    style="display: flex; align-items: center; color: #f06161"
                  >
                    <div class="redTrangle"></div>
                    <div style="font-size: 1vw">{{ item.diff }}</div>
                  </span>
                  <span
                    v-else
                    class="span1"
                    style="display: flex; align-items: center; color: #6bbb57"
                  >
                    <div class="greenTrangle"></div>
                    <div style="font-size: 1vw">
                      {{ item.diff.replace("-", "") }}
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Row>
</template>

<script>
import {
  jwtable,
  getFourPartData,
  jwEchart,
  queryTopEBITDA,
  queryOverSeasEBITDA,
  queryDepartmentRiskIndicators,
} from "../api/index";

const ring = () => import("./components/page1/ring4");
import { useDataStore } from "@/store";
import { mapActions } from "pinia";

export default {
  name: "page3",
  components: {
    ring,
  },
  created() {
    // sysLogin()
    this.getData();
    let userInfo = localStorage.getItem("bbsUserInfo");
    if (userInfo) {
      this.companyName = JSON.parse(userInfo).companyName;
      if (
        JSON.parse(userInfo).homePage == "多个子公司" ||
        JSON.parse(userInfo).homePage == "梅林首页"
      ) {
        this.roleName = JSON.parse(userInfo).roleName;
        this.setTitle(this.roleName);
      } else {
        this.setTitle(JSON.parse(userInfo).companyName);
      }
      let title = JSON.parse(userInfo).companyName;
      if (
        title == "Bright Food Asia Pacific Pty Ltd." ||
        title == "Salov S.p.A"
      ) {
        this.setRightButtonValue(false);
      }
    }
    this.setBackurl("/");
    this.setLeftTop(false);
  },
  data() {
    return {
      roleName: "",
      companyName: "",
      groupData: {}, //梅林的分组数据
      showEbitda: false,
      list: [
        {
          company: "光明国际",
        },
        {
          company: "境内",
          link: "/PC/home_domesitc",
        },
        {
          company: "境外",
          link: "/PC/home_overseas",
        },
      ],
      data1: {},
      data2: [],
      data3: [],
      data4: [],
      data5: [
        [0, 0, 0],
        [0, 0, 0],
        [0, 0, 0],
      ],
      data6: [],
    };
  },
  methods: {
    ...mapActions(useDataStore, [
      "setTitle",
      "setLeftTop",
      "setBackurl",
      "setRightButtonValue",
    ]),
    toIframe(key1, key2) {
      this.$router.push({
        path: `/PC/page/${key1}/${key2}`,
      });
    },
    toEbitda(name) {
      //   this.$router.push(`/PC/page/Ebitda/${name}`);
      this.$router.push(`/PC/page/${name}/EBITDA`);
    },
    async getData() {
      let companyName = "";
      let userInfo = localStorage.getItem("bbsUserInfo");
      if (userInfo) {
        let res = JSON.parse(userInfo);
        companyName = res.companyName;
      }
      // 左上角四个增长率
      const res2 = await getFourPartData({ type: 1 });
      if (res2.code == 200) {
        this.data2 = res2.data;
      }
      //   右边table
      let res3 = {};
      if (
        JSON.parse(userInfo).homePage == "多个子公司" ||
        JSON.parse(userInfo).homePage == "梅林首页"
      ) {
        res3 = await queryDepartmentRiskIndicators({
          companyName,
        });
        if (res3.code == 200) {
          this.groupData = res3.data;
        }
      } else {
        res3 = await jwtable({
          companyName,
        });
        if (res3.code == 200) {
          this.data3 = res3.data;
          let groupData = this.groupBy(res3.data || [], "company");
          this.groupData = groupData;
        }
      }

      //   右边3个echart
      const res4 = await jwEchart({
        companyName,
      });
      if (res4.code == 200) {
        this.data4 = res4.data;
        // console.log(this.data4, 111);
      }

      //   左下角列表
      const res6 = await queryTopEBITDA({
        companyName,
      });
      if (res6.code == 200) {
        this.data6 = res6.data;
      }
      //  境外ebita
      const res5 = await queryOverSeasEBITDA({
        companyName,
      });
      if (res5.code == 200) {
        // res5.data = []
        this.showEbitda = true;
        this.data5 = res5.data;
        let userInfo = localStorage.getItem("bbsUserInfo");
        if (userInfo) {
          if (!res5.data || res5.data.length == 0) {
            this.data5 = [
              {
                isNoShow: true,
                name: JSON.parse(userInfo).companyName,
              },
            ];
          }
        }
      }
    },
    groupBy(arr, key) {
      const grouped = {};
      arr.forEach((obj) => {
        const property = obj[key];
        if (!grouped[property]) {
          grouped[property] = [];
        }
        grouped[property].push(obj);
      });
      return grouped;
    },
    jump(page) {
      if (page) {
        this.$router.push(page);
      }
    },
    getDayDot(res) {
      if (res) {
        // 拿dot颜色
        let riskValue = res["总风险值"];
        if (riskValue == 0) {
          // 绿灯
          return "dot3";
        } else if (riskValue > 0 && riskValue < 99) {
          //黄灯
          return "dot2";
        } else if (riskValue >= 99) {
          //红灯
          return "dot1";
        }
      } else {
        return "-";
      }
    },
  },
  mounted() {},
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFn);
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/index.less";
.subWord {
  color: #bf9d63;
  font-size: 0.9vw;
}
.yellowTitle {
  color: #bf9d63;
  font-family: Microsoft YaHei;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.yellowWrap {
}
.yellowList {
  .yellowItem {
    cursor: pointer;
    display: inline-block;
    margin-right: 1vw;
    margin-top: 1vw;
    width: 16.2vw;
    // height: 9vw;
    overflow: hidden;
    flex-shrink: 0;
    background: rgba(87, 87, 87, 0.4);
    padding: 14px;
    text-align: center;
    .greendot {
      width: 8px;
      height: 8px;
      flex-shrink: 0;
      border-radius: 50%;
      background-color: #59cf7a;
    }
    .dot1 {
      width: 7.5px;
      height: 7.5px;
      border-radius: 50%;
      margin-right: 5px;
      background: #e16a6a;
    }
    .dot2 {
      width: 7.5px;
      height: 7.5px;
      border-radius: 50%;
      margin-right: 5px;
      background: #e4cc88;
    }
    .dot3 {
      width: 7.5px;
      height: 7.5px;
      border-radius: 50%;
      margin-right: 5px;
      background: #59cf7a;
    }
    .yellowline2 {
      width: 100%;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      .number {
        color: #fff;
        font-family: Microsoft YaHei;
        font-size: 1.8vw;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: -2.88px;
        padding-right: 6px;
      }
      .day {
        color: #fff;
        font-family: Microsoft YaHei;
        font-size: 0.8vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding-top: 0.7vw;
      }
    }
    .name {
      color: #fff;
      font-family: Microsoft YaHei;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
}
.red {
}
.green {
  color: #6bbb57;
}
.top-wrapper-item_middle {
  font-weight: 400;
  color: #fff;
  .top-wrapper-item_middle_text {
    &::before {
      content: "";
      display: inline-block;
      width: 12px;
      height: 12px;
      margin-right: 12px;
      border: 3px solid rgba(225, 106, 106, 1);
      border-radius: 100%;
    }

    &.color2::before {
      border-color: rgba(228, 204, 136, 1);
    }
    &.color3::before {
      border-color: rgba(89, 207, 122, 1);
    }
  }
}
.orange3 {
  display: flex;
  color: #fff;
  align-items: center;
  border-radius: 2px;
  background: rgb(147, 127, 86);
  padding-top: 0.5vh;
  padding-bottom: 0.5vh;
  .line {
    width: 1px;
    height: 30px;
    flex-shrink: 0;
    opacity: 0.14000000059604645;
    background: #fff;
  }
  .item {
    font-size: 0.8vw;
    width: 33%;
    text-align: center;
  }
}
.changeRate {
  padding-left: 3%;
  padding-right: 4%;
  width: 100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(to left, #bf9d63, #bf9d63) left top no-repeat,
    linear-gradient(to bottom, #bf9d63, #bf9d63) left top no-repeat,
    linear-gradient(to left, #bf9d63, #bf9d63) right top no-repeat,
    linear-gradient(to bottom, #bf9d63, #bf9d63) right top no-repeat,
    linear-gradient(to left, #bf9d63, #bf9d63) left bottom no-repeat,
    linear-gradient(to bottom, #bf9d63, #bf9d63) left bottom no-repeat,
    linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat,
    linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat;
  background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
  padding: 10px 20px;
  .changeRateTitle {
    color: #bf9d63;
    // margin-bottom: 10px;
  }
}
.redTrangle {
  /* 1.首先设置盒子宽高都为0 */
  width: 0;
  height: 0;
  /*2.设置盒子上下左右边框(注意:根据三角形大小调整边框粗细,颜色要设置为透明transparent) */
  border: 4px solid transparent;
  /*3.根据三角形方向选择设置哪个方向边框为none
                技巧:设置三角形正对方向的边框为none,比如我想设置朝上的三角形，那就设置上边框为none*/
  border-top: none;
  /*4.最后设置边框颜色，显示出三角形*/
  border-bottom-color: #f06161;
  margin-right: 3px;
}
.greenTrangle {
  width: 0px;
  height: 0px;
  border: 4px solid transparent;
  border-top-color: #6bbb57;
  margin-right: 3px;
}
.buPartWrap {
  cursor: pointer;
  display: inline-block;
  width: 100%;
  height: 4.5vw;
  // height: 180px;
  //   background: rgba(87, 87, 87, 0.3);
  //   border: 1px solid #4d4a48;
  margin-top: 1vw;
  &:first-child {
    margin-top: 1.2vw;
  }
  &:nth-child(n + 1) {
    // margin-top: 2vw;
  }
  .buPart {
    width: 100%;
    height: 100%;
    background: linear-gradient(to left, #bf9d63, #bf9d63) left top no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) left top no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right top no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) right top no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) left bottom no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) left bottom no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat;
    background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
    padding-left: 1vw;
    padding-right: 1vw;
    padding-top: 0.5vw;
    padding-bottom: 0.5vw;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    // padding: 1.5vw 20px 0;
    .buPartTitle {
      color: #bf9d63;
      // font-weight: 600;
      // margin-bottom: 28px;
      //   font-size: 20px;
      font-size: 1.2vw;
      line-height: 27px;
    }
    .line {
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 34px;
      .span1 {
        color: #ffffff;
        opacity: 0.6;
        font-size: 1.2vw;
        // font-size: 1vw;
      }
      .span2 {
        font-size: 1.4vw;
        color: #ffffff;
        opacity: 0.8;
        // font-size: 1.5vw;
      }
    }
  }
  background: rgba(87, 87, 87, 0.3);
  border: 1px solid #4d4a48;
  box-sizing: border-box;
}
.center-bottom {
  background: rgba(87, 87, 87, 0.3);
  border: 1px solid #4d4a48;
  .background-4-img;
  padding: 20px;
  .center-bottom-title {
    font-size: 16px;
    line-height: 24px;
    color: rgba(191, 157, 99, 1);
    font-weight: 300;
  }
}
.dot {
  margin-right: 10px;
  display: inline-block;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  background: linear-gradient(180deg, #bf9d63 0%, rgba(217, 217, 217, 0) 100%);
}

.tableList {
  .item {
    display: flex;
    align-items: center;
    &:nth-child(odd) {
      background: rgba(87, 87, 87, 0.5);
    }
    height: 38px;
    line-height: 38px;
    justify-content: space-between;
    .left {
      font-size: 1vw;
      color: #ffffff;
      opacity: 0.6;
      padding-left: 10px;
    }
    .center {
      font-weight: 400;
      font-size: 1vw;
      color: #ffffff;
      text-align: center;
    }
    .right {
      text-align: right;
      padding-right: 10px;
      font-weight: 400;
      font-size: 1vw;
      color: #f06161;
      .dotRed {
        position: relative;
        bottom: 0.1vw;
        display: inline-block;
        margin-right: 5px;
        width: 0.5vw;
        height: 0.5vw;
        // border-radius: 50%;
        // background: #f06161;
        /* 1.首先设置盒子宽高都为0 */
        width: 0.5vw;
        height: 0.5vw;
        /*2.设置盒子上下左右边框(注意:根据三角形大小调整边框粗细,颜色要设置为透明transparent) */
        border: 6px solid transparent;
        /*3.根据三角形方向选择设置哪个方向边框为none
                技巧:设置三角形正对方向的边框为none,比如我想设置朝上的三角形，那就设置上边框为none*/
        border-top: none;
        /*4.最后设置边框颜色，显示出三角形*/
        border-bottom-color: #f06161;
      }
      .dotGreen {
        position: relative;
        top: 0.1vw;
        display: inline-block;
        // border-radius: 50%;
        // background: #6bbb57;
        width: 0.5vw;
        height: 0.5vw;
        border: 6px solid transparent;
        border-top-color: #6bbb57;
        margin-right: 5px;
      }
    }
    > div {
      width: 33%;
    }
  }
}
.changeRateWrap {
  flex: 1;
  background: rgba(87, 87, 87, 0.3);
  border: 1px solid #4d4a48;
  //   height: calc(100% - 32px - 40%);
  position: relative;
  //   top: -20px;

  .changeRateTitle {
    display: flex;
    align-items: center;

    .word {
      font-size: 16px;
      color: #bf9d63;
    }
  }
}
.page3 {
  .left1 {
    .changeItem {
      font-size: 0.9vw;
      margin-bottom: 20px;
      position: relative;
      //   top: -60px;

      .item {
        cursor: pointer;
        text-align: center;
        display: inline-block;
        // margin-right: 40px;
        min-width: 105px;
        height: 40px;
        line-height: 40px;
        color: #bf9d63;
        // padding: 8px 14px;
        color: #fff;
        &.active {
          background: #4a3e29;
          border-radius: 60px;
          color: #bf9d63;
        }
      }
    }
  }
  height: 100%;
  width: 100%;
  padding: 14px 20px 20px;
  //   background: #03044a;
  // overflow: hidden;

  .ivu-col {
    height: 100%;
    float: left;
  }

  .left,
  .right1-1,
  .center-bottom {
    // background: rgba(87, 87, 87, 0.3);
    // border: 1px solid #4d4a48;
    height: 100%;
    // border: 1px solid #0d2451;
    position: relative;
    // background: #151456;

    #left_5 {
      height: 100%;
      width: 45%;
      float: left;
    }

    #left_6 {
      height: 100%;
      width: 55%;
      float: left;
    }

    .circular {
      height: 100%;

      .canvas {
        height: 100%;
        width: 30%;
        float: left;

        .subtitle {
          font-size: 12px;
          font-weight: bold;
          color: #fff;
          height: 25px;
          padding: 10px 0;
          text-align: center;
        }

        .canvasList {
          height: calc(~"100% - 25px");
          text-align: center;
        }
      }
    }

    .left1 {
      //   border-bottom: 1px solid #0d2451;
      //   background: #151456;
    }

    .title {
      position: absolute;
      display: inline-block;
      color: #6eddf1;
      border: 2px solid #6eddf1;
      height: 18px;
      padding: 0 2px;
      left: 50%;
      transform: translate(-50%, -50%);

      .title-text {
        position: relative;
        font-size: 16px;
        background: #09102e;
        display: inline-block;
        padding: 0 4px;
        transform: translateY(-5px);
      }
    }
  }

  .center-top {
    height: 70%;
  }

  .center-bottom {
    height: 30%;

    .bottom-radars {
      height: 100%;
    }

    .bottom-bars {
      height: 45%;
    }
  }

  .right-1 {
    height: 30%;

    .right1-1 {
      height: 92%;
    }
  }

  .right-2 {
    height: 40%;
  }
}
</style>
